import MDEditor from '@uiw/react-md-editor';
import rehypeSanitize from 'rehype-sanitize';

interface MessageContentProps {
  content: string;
}

// Synthesis emits `[N]` citation markers tied to tool indices. We keep
// them in the persisted response (devs need them for the trace inspector)
// but strip them at render time so providers see clean prose. Eats the
// whitespace immediately before the marker to avoid leftover orphan
// spaces between a word and the punctuation that follows.
const stripCitationMarkers = (content: string) =>
  content.replace(/\s*\[\d+\]/g, '');

export const MessageContent = ({ content }: MessageContentProps) => {
  return (
    <MDEditor.Markdown
      source={stripCitationMarkers(content)}
      rehypePlugins={[rehypeSanitize]}
    />
  );
};
